import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBadgeSuccess = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM18.7071 8.70711C19.0976 8.31658 19.0976 7.68342 18.7071 7.29289C18.3166 6.90237 17.6834 6.90237 17.2929 7.29289L10.0829 14.5029L6.78087 10.3753C6.43586 9.94404 5.80657 9.87412 5.37531 10.2191C4.94404 10.5641 4.87412 11.1934 5.21913 11.6247L9.21913 16.6247C9.39682 16.8468 9.66069 16.9827 9.9447 16.9985C10.2287 17.0142 10.506 16.9082 10.7071 16.7071L18.7071 8.70711Z",
		fill: "#007B46"
	})
});
export default SvgBadgeSuccess;
